let cdnjs = {
    "picturefill": "https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.min.js",
    "touchswipe": "https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.18/jquery.touchSwipe.min.js",
    "headroom": "https://cdnjs.cloudflare.com/ajax/libs/headroom/0.9.4/headroom.min.js",
    "masonry": "https://cdnjs.cloudflare.com/ajax/libs/masonry/4.1.1/masonry.pkgd.min.js",
    "sticky": "https://cdnjs.cloudflare.com/ajax/libs/sticky-kit/1.1.3/sticky-kit.min.js",
    "lui_scrollbanner": "https://packages.newlogic.cz/newlogic-scrollbanner/1.0.2/js/newlogic-scrollbanner.min.js",
    "lui_exitbanner": "https://packages.newlogic.cz/newlogic-exitbanner/1.0.2/js/newlogic-exitbanner.min.js"
};